// Catégorisation des photos clients (hébergées dans /public/centers/).
// Toutes accessibles via /centers/<name>.jpg
const P = (name) => `/centers/${name}.jpg`;

export const PHOTOS = {
  // Banc de puissance
  dyno: [
    { src: P("img_5048"), label: "Audi RS Q8 - Banc de puissance" },
    { src: P("img_5504"), label: "Audi RS Q8 - Mesure de couple" },
    { src: P("img_9154"), label: "Porsche 911 Turbo S - Dyno" },
    { src: P("img_9165"), label: "BMW M2 - Banc Stage 2" },
    { src: P("img_9595"), label: "Toyota Supra - Test puissance" },
    { src: P("img_9605"), label: "Volkswagen Golf R - Stage 1" },
  ],
  // Ateliers, lifts, intérieur
  interior: [
    { src: P("img_8467"), label: "Atelier équipé pro" },
    { src: P("img_9020"), label: "Postes de travail et ponts" },
    { src: P("img_5148"), label: "Ferrari capot ouvert - en cours" },
    { src: P("img_8154"), label: "Audi RS Q8 - Préparation moteur" },
    { src: P("img_8468"), label: "Sol checker — esprit garage premium" },
    { src: P("img_8135"), label: "Volkswagen Polo - reprog en cours" },
  ],
  // Véhicules clients spectaculaires
  cars: [
    { src: P("img_4607"), label: "Lamborghini Huracán" },
    { src: P("img_6282"), label: "Ferrari Spider bleue" },
    { src: P("img_5132"), label: "Ferrari 488" },
    { src: P("img_7829"), label: "Nissan GT-R" },
    { src: P("img_5002"), label: "Porsche 911 GT3" },
    { src: P("img_8137"), label: "Porsche 911 GT3 - Vue arrière" },
    { src: P("img_4202"), label: "Mercedes-AMG GT R" },
    { src: P("img_4199"), label: "BMW M4 Compétition" },
    { src: P("img_4512"), label: "BMW M3 Compétition" },
    { src: P("img_6888"), label: "Ford Mustang GT" },
    { src: P("img_7945"), label: "Ford Mustang Mach 1" },
    { src: P("img_9074"), label: "Ferrari convertible" },
    { src: P("img_2193"), label: "Mercedes AMG A45 S" },
    { src: P("img_2546"), label: "Yamaha R1 - Reprog moto" },
    { src: P("img_2649"), label: "Porsche Cayenne" },
    { src: P("img_5437"), label: "Ferrari grise" },
    { src: P("img_8134"), label: "Porsche 718 Boxster" },
    { src: P("img_8136"), label: "Ferrari rouge" },
    { src: P("img_8149"), label: "Deux Mercedes-AMG" },
    { src: P("img_9745"), label: "Chevrolet Camaro SS" },
    { src: P("img_1814"), label: "Mercedes Classe C AMG" },
    { src: P("img_8145"), label: "BMW R 1250 GS" },
  ],
  // Action - clients accueillis devant les centres
  action: [
    { src: P("img_8153"), label: "Ferrari devant Horsepower" },
    { src: P("img_8480"), label: "Aston Martin Vantage - Horsepower Montpellier" },
    { src: P("img_8481"), label: "Livraison client" },
  ],
  // Équipe
  team: [
    { src: P("img_8397"), label: "L'équipe Horsepower" },
  ],
};

// Pré-sélection bento : 8 photos clés pour la galerie hero
export const BENTO_PHOTOS = [
  { ...PHOTOS.dyno[1], tag: "Banc de puissance" },        // RS Q8 dyno (big)
  { ...PHOTOS.cars[0], tag: "Véhicule client" },           // Lambo Huracan
  { ...PHOTOS.interior[0], tag: "Atelier" },               // Workshop clean
  { ...PHOTOS.cars[3], tag: "Préparation" },               // GT-R
  { ...PHOTOS.action[1], tag: "Centre Montpellier" },      // Aston entrance
  { ...PHOTOS.dyno[3], tag: "Stage 2" },                   // BMW M2 dyno
  { ...PHOTOS.cars[1], tag: "Reprogrammation" },           // Ferrari Spider
  { ...PHOTOS.interior[2], tag: "Diagnostic" },            // Ferrari hood open
];

// Marquee : toutes les voitures + actions pour scroll horizontal infini
export const MARQUEE_PHOTOS = [
  ...PHOTOS.cars,
  ...PHOTOS.action,
  ...PHOTOS.dyno,
];
